import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "@/router/routePaths"
import { CX_CORE_FEATURES_ENUM } from "@/common/util/featuresUtil"
import { guardedImport } from "@/router/guardedImport"

const applicationRoutes: RouteRecordRaw[] = [
  {
    path: "/applications",
    name: "applications",
    component: () => import("@/layout/AbstractRouteView.vue"),
    meta: {
      isProtected: true
    },
    children: [
      {
        path: routePaths.applications.electronicControlUnit.path,
        name: routePaths.applications.electronicControlUnit.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.ELECTRONIC_CONTROL_UNIT,
          () =>
            import("@/modules/applications/electronicControlUnit/pages/ElectronicControlUnit.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "Electronic Control Unit",
              translationKey: "sideMenu.electronicControlUnit",
              routeName: routePaths.applications.electronicControlUnit.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.certificateManagement.path,
        name: routePaths.applications.certificateManagement.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.CERTIFICATE_MANAGEMENT,
          () =>
            import("@/modules/applications/certificateManagement/pages/CertificateManagement.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "Business Partner Certificate Management",
              translationKey: "certificateManagement.title",
              routeName: routePaths.applications.certificateManagement.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.pcfExchange.path,
        name: routePaths.applications.pcfExchange.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.PCF_EXCHANGE,
          () => import("@/modules/applications/pcfExchange/pages/PcfExchange.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "PCF Exchange v7",
              translationKey: "sideMenu.pcfExchange",
              routeName: routePaths.applications.pcfExchange.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.pcfExchangeV9.path,
        name: routePaths.applications.pcfExchangeV9.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.PCF_EXCHANGE,
          () => import("@/modules/applications/pcfExchangeV9/pages/PcfExchange.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "PCF Exchange v9",
              translationKey: "sideMenu.pcfExchangeV9",
              routeName: routePaths.applications.pcfExchangeV9.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.blockNotifications.path,
        name: routePaths.applications.blockNotifications.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.BLOCK_NOTIFICATIONS,
          () => import("@/modules/applications/blockNotifications/pages/BlockNotifications.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "blockNotifications.title",
              translationKey: "blockNotifications.title",
              routeName: routePaths.applications.blockNotifications.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.traceability.path,
        name: routePaths.applications.traceability.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.TRACEABILITY,
          () => import("@/modules/applications/traceability/pages/Traceability.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "traceability.title",
              translationKey: "traceability.title",
              routeName: routePaths.applications.traceability.pathName
            }
          ]
        }
      },
      {
        path: routePaths.applications.cyberSecurityKPIs.path,
        name: routePaths.applications.cyberSecurityKPIs.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.CYBERSECURITY_KPIS,
          () => import("@/modules/applications/cybersecurityKPIs/pages/CyberSecurityKPI.vue")
        ),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "sideMenu.applications",
              translationKey: "sideMenu.applications",
              routeName: ""
            },
            {
              title: "Cybersecurity KPIs",
              translationKey: "cyberSecurityKPIs.title",
              routeName: routePaths.applications.cyberSecurityKPIs.pathName
            }
          ]
        }
      }
    ]
  }
]

export default applicationRoutes
